import React from 'react';
import {Checkbox, CouponModal, CustomDropdown} from "../../utilites";
import TrashIcon from "../../../assets/icons/trash.svg";
import Coupon from "../Coupon";

const CouponsTabPanel = ({
                             cashBox,
                             checkedCoupons,
                             allCheckedSameStatus,
                             isCopyButtonRender,
                             changeModalState,
                             handleCouponChange,
                             handleActivate,
                             handleDelete,
                             handleInactiveCheck,
                             handleOnAllCouponCheck,
                             handleOnCouponCheck,
                             showModalCouponEdit,
                             showModalCouponCopy,
                             showModalCouponAdd,
                             modalMode,
                             inactiveCheck,
                             allChecked,
                             isAnnuity
                         }) => {
    return (
        <div>
            <div className="content-datatable">
                <div className="content-datatable-header">
                    <React.Fragment>
                        <div className="content-datatable-header-left">
                            <div className="action-items">
                                {cashBox.coupons && cashBox.coupons.length > 0 &&
                                    <React.Fragment>
                                        <button
                                            className={checkedCoupons.length > 0 ? "action-item" : "disabled-action-item"}
                                            onClick={() => {
                                                if (checkedCoupons.length > 0) {
                                                    changeModalState("showModalCouponEdit", true)
                                                }
                                            }}>Редактировать
                                        </button>
                                        {checkedCoupons.length > 0 && showModalCouponEdit &&
                                            <CouponModal
                                                cashBoxId={cashBox.id}
                                                initialValue={checkedCoupons}
                                                flag={showModalCouponEdit}
                                                close={() => changeModalState("showModalCouponEdit", false)}
                                                onSuccess={handleCouponChange}
                                                isAnnuity={isAnnuity}
                                                />}
                                    </React.Fragment>
                                }
                                {cashBox.coupons && cashBox.coupons.length > 0 &&
                                    <React.Fragment>
                                        <button
                                            className={checkedCoupons.length > 0 && allCheckedSameStatus ? "action-item" : "disabled-action-item"}
                                            onClick={() => {
                                                if (checkedCoupons.length > 0 && allCheckedSameStatus) {
                                                    handleActivate(checkedCoupons)
                                                }
                                            }}>
                                            {checkedCoupons && checkedCoupons.length > 0 && checkedCoupons[0].active ? 'Деактивировать' : 'Активировать'}
                                        </button>
                                    </React.Fragment>
                                }
                                {isCopyButtonRender &&
                                    <>
                                        <button
                                            className={checkedCoupons.length > 0 ? "action-item" : "disabled-action-item"}
                                            onClick={() => {
                                                if (checkedCoupons.length > 0) {
                                                    changeModalState("showModalCouponCopy", true)
                                                    changeModalState("modalMode", 'copy')
                                                }
                                            }}>Копировать
                                        </button>
                                        {showModalCouponCopy &&
                                            <CouponModal
                                                cashBoxId={cashBox.id}
                                                initialValue={checkedCoupons}
                                                flag={showModalCouponCopy}
                                                modalMode={modalMode}
                                                close={() => changeModalState("showModalCouponCopy", false)}
                                                onSuccess={handleCouponChange}
                                                isAnnuity={isAnnuity}/>}
                                    </>
                                }

                                <button className="action-item"
                                        onClick={() => changeModalState("showModalCouponAdd", true)}>Добавить
                                    новый купон
                                </button>
                                {showModalCouponAdd &&
                                    <CouponModal cashBoxId={cashBox.id}
                                                 flag={showModalCouponAdd}
                                                 close={() => changeModalState("showModalCouponAdd", false)}
                                                 onSuccess={handleCouponChange}
                                                 isAnnuity={isAnnuity}/>}
                            </div>
                        </div>
                        <div className="content-datatable-header-center">
                            <div className="action-items">
                                <CustomDropdown disabled={!(checkedCoupons && checkedCoupons.length > 0)}
                                                triggerText={"Удалить"}
                                                additionalClasses={"flex-shrink-0"}
                                                headText={"Вы уверены что хотите удалить выбранные купоны?"}
                                                onAction={() => {
                                                    if (checkedCoupons.length > 0) {
                                                        handleDelete(checkedCoupons)
                                                    }
                                                }}
                                                buttonText={"Удалить"}>
                                    <TrashIcon/>
                                </CustomDropdown>
                            </div>
                        </div>

                        <div className="content-datatable-header-right">
                            <div className="action-items">
                                <Checkbox label='Показать неактивные' onChange={handleInactiveCheck}
                                          id={'inactiveCheck'} value={inactiveCheck}
                                          name='inactiveCheck'/>
                            </div>
                        </div>
                    </React.Fragment>
                </div>
            </div>

            {cashBox.coupons && cashBox.coupons.length > 0 &&
                <React.Fragment>
                    <div className="block-datacollapseheader">
                        <Checkbox onChange={handleOnAllCouponCheck}
                                  id="checkboxCouponAll" value={allChecked}
                                  name="checkboxCouponAll"
                                  label={'Выбрать все купоны'}
                                  dashed={true}/>
                    </div>
                    {cashBox.coupons.map((coupon, index) => {
                        return (<div className="block-datacollapse" key={index}>
                            <Checkbox label={''} onChange={handleOnCouponCheck}
                                      id={coupon.id} value={coupon.checked}
                                      name={'checkboxCoupon'}
                                      classes="m-t-spacer-1-5"/>
                            <Coupon coupon={coupon} isBase={false} isAnnuity={isAnnuity}/>
                        </div>)
                    })}
                </React.Fragment>
            }
        </div>
    );
};

export default CouponsTabPanel;